import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminLayout from "../../LayoutWrapper/AdminLayout";
import PolicyOutlinedIcon from "@mui/icons-material/PolicyOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { PRIVACY_INTRO, PRIVACY_SECTIONS } from "./content";
import "../../CSS/PrivacyPolicy/modern.css";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = PRIVACY_SECTIONS.map((s) => ({
        id: s.id,
        el: document.getElementById(s.id),
      }));
      const scrollPos = window.scrollY + 120;
      let current = "";
      sectionElements.forEach(({ id, el }) => {
        if (el && el.offsetTop <= scrollPos) {
          current = id;
        }
      });
      setActiveSection(current);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <AdminLayout>
      <div className="privacy-page">
        <section className="privacy-hero">
          <div className="privacy-hero__inner">
            <span className="privacy-hero__badge">
              <PolicyOutlinedIcon sx={{ fontSize: 18 }} />
              Legal
            </span>
            <h1 className="privacy-hero__title">{t("page_title_privacy_policy")}</h1>
            <p className="privacy-hero__meta">Last updated: May 2026</p>
          </div>
        </section>

        <section className="privacy-body">
          <div className="privacy-body__inner">
            <nav className="privacy-toc" aria-label="Table of contents">
              <p className="privacy-toc__title">On this page</p>
              <ul className="privacy-toc__list">
                {PRIVACY_SECTIONS.map((section) => (
                  <li key={section.id}>
                    <a
                      href={`#${section.id}`}
                      className={`privacy-toc__link${
                        activeSection === section.id ? " privacy-toc__link--active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(section.id);
                      }}
                    >
                      {section.title}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="privacy-content">
              <div className="privacy-intro">
                <h2 className="privacy-section__title">
                  What Information Will We Collect?
                </h2>
                {PRIVACY_INTRO.map((paragraph) => (
                  <p key={paragraph.slice(0, 50)}>{paragraph}</p>
                ))}
              </div>

              {PRIVACY_SECTIONS.map((section) => (
                <article key={section.id} id={section.id} className="privacy-section">
                  <h2 className="privacy-section__title">{section.title}</h2>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph.slice(0, 50)}>{paragraph}</p>
                  ))}
                  {section.listItems && (
                    <ul>
                      {section.listItems.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </article>
              ))}

              <div className="privacy-cta">
                <h3 className="privacy-cta__title">Questions about this policy?</h3>
                <p className="privacy-cta__text">
                  Contact our team for clarifications about your data and privacy rights.
                </p>
                <Link to="/contact" className="privacy-cta__link">
                  Contact us
                  <ArrowForwardIcon fontSize="small" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </AdminLayout>
  );
};

export default PrivacyPolicy;
